<template>
  <router-view/>
</template>

<script>
export default {
  name: 'HistoryMain'
}
</script>

<style scoped>

</style>
